import { userLogInRequest, userLogInFailure } from '../actions'
import { decodeQueryString, setCookie, removeCookie, getCookie } from 'utils'

const initRoutine = store => {
	const queryParams = decodeQueryString(window.location.hash.replace('#', ''))
	const { access_token, expires_in } = queryParams
	const accessTokenFromCookie = getCookie('access_token')

	if (typeof access_token !== 'undefined') {
		removeCookie('access_token')
		setCookie('access_token', access_token, {
			days: expires_in ? parseInt(expires_in, 10) / 86400 : 14,
			path: '/'
		})
		store.dispatch(userLogInRequest(access_token))
	} else if (accessTokenFromCookie !== null) {
		store.dispatch(userLogInRequest(accessTokenFromCookie))
	} else {
		store.dispatch(userLogInFailure('Not authorized'))
	}
}

export default initRoutine



// WEBPACK FOOTER //
// ./src/utils/initRoutine.js